import React from 'react';

import Header from '../components/header/Header';
import Upload from '../components/upload/Upload';

const upload = () => {
    return (
        <div>
            <Header />
            <Upload />
        </div>
    );
};

export default upload;


// WEBPACK FOOTER //
// ./src/pages/upload.js